import { useMemo } from "react";
import Select from "react-select";
import { useShowAllOltHooksWithFilter } from "../../../utils/infrastructure/OltUtils";

export default function OltSelect({ value, project_id = "", required = false, onChange }) {
  const { data } = useShowAllOltHooksWithFilter({ filter: { project_id } });

  const oltList = useMemo(() => {
    return data.map((oltVal) => ({
      value: oltVal.id,
      label: oltVal.name,
    }));
  }, [data]);

  const selectedValue = useMemo(() => {
    if (!value) return null;
    return oltList.find((olt) => olt.value === value) || null;
  }, [value, oltList]);

  const handleChange = (selected) => {
    onChange(selected?.value || "");
  };

  return (
    <>
      <Select
        value={selectedValue}
        isClearable
        placeholder="Pilih OLT"
        onChange={handleChange}
        options={oltList}
        required={required}
      />
    </>
  );
}
